// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__29OOQ","heading":"Skills_heading__9Olu3","skillContainer":"Skills_skillContainer__C-Zx-","Skills":"Skills_Skills__sC-YK"};